<template>

    <section v-if="article" class="bg-white" style="min-height: inherit; padding-bottom: 70px;">
        <div class="container" style="max-width: 650px;">
            <div class="text-title" v-html="article.title" />
            <div class="text-grey-7">{{ article.dateCreated | date }}</div>

            <div class="fit-imgs module" v-html="article.body" />

        </div>
        <div class="row justify-between absolute-bottom container">
            <q-btn color="primary" icon="mdi-arrow-left-bold"
                   :label="screenSize.xs ? undefined : 'Prev'" align="left"
                   :disabled="prevArticle() == ''"
                   :to="prevArticle()" />

            <q-btn color="primary" icon="mdi-newspaper"
                   :label="screenSize.xs ? undefined : 'More News'" align="center"
                   to="/news" />

            <q-btn color="primary" icon-right="mdi-arrow-right-bold"
                   :label="screenSize.xs ? undefined : 'Next'" align="right"
                   :disabled="nextArticle() == ''"
                   :to="nextArticle()" />
        </div>
        <q-inner-loading :showing="getArticlesPending">
            <div>
                <q-spinner color="primary"
                           :thickness="2"
                           size="3em" />
            </div>
        </q-inner-loading>
    </section>

</template>
<script>
    import { mapState } from 'vuex'

    export default {
        name: 'article',
        props: {
            id: String,
        },

        data() {
            return {
                articles: [],
            }
        },
        methods: {

            getArticles() {
                this.$store.dispatch('getArticles').then(() => {
                    this.articles = this.getArticlesData
                })
            },
            prevArticle() {
                let index = this.articles.indexOf(this.article)
                let prevItem
                if (index > 0 && index <= this.articles.length - 1) {
                    prevItem = this.articles[index - 1]
                    return '/news/article/' + prevItem.id
                }
                return ''
            },
            nextArticle() {
                let index = this.articles.indexOf(this.article)
                let nextItem
                if (index >= 0 && index < this.articles.length - 1) {
                    nextItem = this.articles[index + 1]
                    return '/news/article/' + nextItem.id
                }
                return ''
            }
        },
        computed: {
            ...mapState([
                'getArticlesData',
                'getArticlesPending'
            ]),
            article() {
                return this.articles?.find(a => a.id == this.id)
            },
            screenSize() {
                return this.$q.screen
            },

        },
        created() {
            this.getArticles()
        }
    }
</script>
